<script>
import { h } from 'vue'

export default {
  name: 'RenderOption',
  props: {
    dom: {
      type: Array,
      required: true
    }
  },
  render() {
    return h(
      'div',
      {
        attrs: { class: 'render-option' }
      },
      this.dom
    )
  }
}
</script>

<style lang="scss" scoped>
.render-option {
  display: flex;
  gap: 0.5rem;
  color: $text-primary;
  width: 100%;
}
</style>
